import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

extend('name', {
    validate: value => /^[a-zA-Z \/]+$/.test(value),
    message: 'Name should contain only alphabets and spaces'
});

extend('number_only', {
    validate: value => /^[0-9]+$/.test(value),
    message: 'The value must be a number'
});

extend('nric', {
    validate: value => String(value).length > 11,
    message: 'The value must be a number with a maximum length of 12 characters'
});

extend('email', {
    ...email,
    message: 'Please enter a valid email address'
});

extend('mobile_no', {
    validate: value => {
        // Check if the value matches the pattern for a Malaysian phone number
        return /^(\+?6?01)[02-46-9]-*[0-9]{7}$|^(\+?6?01)[1]-*[0-9]{8}$/.test(value);
    },
    message: 'Please enter a valid mobile phone number in Malaysia without any ' + '-'
});

extend('phone_prefix', {
    validate: value => {
        // Check if the value matches the pattern for a Malaysian phone number
        return /^((03|04|05|06|07|080|081|082|083|084|085|086|087|089|09)\d{7,8})$/.test(value);
    },
    message: 'Please enter a valid landline phone number in Malaysia'
});

extend('postcode', {
    validate: value => /^\d{5}(?:[-\s]\d{4})?$/.test(value),
    message: 'Please enter a valid postcode'
});

extend('currency', {
    validate: value => /^\d*\.?\d{0,2}$/.test(value),
    message: 'The value must be a number and restricted to two decimal places'
});